'use client';

import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["slots", "slotProps", "className", "classes"];
import * as React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { UnreadMarker } from '@mui/x-chat-headless';
import { styled, createUseThemeProps } from "../internals/zero-styled/index.mjs";
import { useChatUnreadMarkerUtilityClasses } from "./chatUnreadMarkerClasses.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
const useThemeProps = createUseThemeProps('MuiChatUnreadMarker');
const ChatUnreadMarkerStyled = styled('div', {
  name: 'MuiChatUnreadMarker',
  slot: 'Root',
  overridesResolver: (_, styles) => styles.root
})(({
  theme
}) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  paddingInline: theme.spacing(2),
  paddingBlock: theme.spacing(0.5)
}));
const ChatUnreadMarkerLabelStyled = styled('div', {
  name: 'MuiChatUnreadMarker',
  slot: 'Label',
  overridesResolver: (_, styles) => styles.label
})(({
  theme
}) => ({
  fontSize: theme.typography.caption.fontSize,
  fontWeight: theme.typography.fontWeightMedium,
  color: (theme.vars || theme).palette.primary.main,
  whiteSpace: 'nowrap'
}));
const ChatUnreadMarker = /*#__PURE__*/React.forwardRef(function ChatUnreadMarker(inProps, ref) {
  const props = useThemeProps({
    props: inProps,
    name: 'MuiChatUnreadMarker'
  });
  const {
      slots,
      slotProps,
      className,
      classes: classesProp
    } = props,
    other = _objectWithoutPropertiesLoose(props, _excluded);
  const classes = useChatUnreadMarkerUtilityClasses(classesProp);
  return /*#__PURE__*/_jsx(UnreadMarker, _extends({
    ref: ref
  }, other, {
    slots: _extends({
      root: slots?.root ?? ChatUnreadMarkerStyled,
      label: slots?.label ?? ChatUnreadMarkerLabelStyled
    }, slots),
    slotProps: _extends({}, slotProps, {
      root: _extends({
        className: clsx(classes.root, className)
      }, slotProps?.root),
      label: _extends({
        className: classes.label
      }, slotProps?.label)
    })
  }));
});
if (process.env.NODE_ENV !== "production") ChatUnreadMarker.displayName = "ChatUnreadMarker";
process.env.NODE_ENV !== "production" ? ChatUnreadMarker.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  classes: PropTypes.object,
  className: PropTypes.string,
  index: PropTypes.number,
  items: PropTypes.arrayOf(PropTypes.string),
  label: PropTypes.node,
  messageId: PropTypes.string.isRequired,
  slotProps: PropTypes.object,
  slots: PropTypes.object
} : void 0;
export { ChatUnreadMarker };